import { render, staticRenderFns } from "./Permission.vue?vue&type=template&id=055e0b8a&scoped=true&"
import script from "./Permission.vue?vue&type=script&lang=js&"
export * from "./Permission.vue?vue&type=script&lang=js&"
import style0 from "./Permission.vue?vue&type=style&index=0&id=055e0b8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055e0b8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('055e0b8a')) {
      api.createRecord('055e0b8a', component.options)
    } else {
      api.reload('055e0b8a', component.options)
    }
    module.hot.accept("./Permission.vue?vue&type=template&id=055e0b8a&scoped=true&", function () {
      api.rerender('055e0b8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/dashboard/practice-info/Permission.vue"
export default component.exports